// Mapping helpers for payment method logos

const LOGOS = {
  // Banks (Virtual Accounts)
  BNI: '/logos/bank-bni.svg',
  BRI: '/logos/bank-bri.svg',
  BCA: '/logos/bank-bca.svg',
  MANDIRI: '/logos/bank-mandiri.svg',
  PERMATA: '/logos/bank-permata.svg',
  CIMB: '/logos/bank-cimb.svg',
  BJB: '/logos/bank-bjb.svg',
  BSI: '/logos/bank-bsi.svg',
  BSS: '/logos/bank-generic.svg',

  // Stores (OTC)
  INDOMARET: '/logos/store-indomaret.svg',

  // Other
  QRIS: '/logos/qris.svg',
  CARD: '/logos/card-generic.svg',
  EWALLET: '/logos/ewallet-generic.svg',
  PAYLATER: '/logos/paylater-generic.svg'
};

export function getLogoForChannelCode(code) {
  if (!code) return LOGOS['bank-generic'] || '/logos/bank-generic.svg';
  const key = String(code).toUpperCase();
  return LOGOS[key] || '/logos/bank-generic.svg';
}

export function getLogoForMethod(method) {
  if (!method) return '/logos/bank-generic.svg';
  // Prefer channelCode-specific logo when present
  if (method.channelCode) {
    const byChannel = getLogoForChannelCode(method.channelCode);
    if (byChannel) return byChannel;
  }
  // Fallback by type
  const type = String(method.type || '').toUpperCase();
  return LOGOS[type] || '/logos/bank-generic.svg';
}

